export const SwishLogoAlt = `<svg xmlns="http://www.w3.org/2000/svg" width="93" height="86" viewBox="0 0 93 86" fill="none">
<g clip-path="url(#clip0_19220_90181)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M26.418 81.2884C45.0753 89.5494 68.1012 85.4605 82.015 70.1123C98.5013 51.9223 95.9446 24.8012 76.2942 9.54102L63.2308 23.9502C78.5814 35.8746 80.5834 57.0579 67.6997 71.2714C57.4308 82.6041 40.5166 86.3849 26.418 81.2835" fill="url(#paint0_linear_19220_90181)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M26.418 81.2874C45.0753 89.5485 68.1012 85.4595 82.015 70.1113C83.7212 68.2331 85.2161 66.2571 86.5156 64.2078C88.713 51.5692 83.8796 38.2067 72.5173 29.3783C69.6278 27.1333 66.5059 25.3285 63.2361 23.9492C78.5814 35.8737 80.5834 57.057 67.705 71.2705C57.4361 82.6031 40.5219 86.3839 26.4233 81.2825" fill="url(#paint1_linear_19220_90181)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M66.4613 3.66175C47.804 -4.5993 24.7781 -0.510346 10.8644 14.8379C-5.62194 33.0278 -3.06527 60.1489 16.5852 75.4091L29.6485 61C14.2979 49.0755 12.2959 27.8922 25.1796 13.6787C35.4485 2.34605 52.3627 -1.43965 66.4613 3.66175Z" fill="#183E4F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M66.4623 3.66175C47.8049 -4.59929 24.7791 -0.510346 10.8653 14.8379C9.15907 16.7161 7.66416 18.6921 6.3647 20.7414C4.16723 33.38 9.0006 46.7425 20.363 55.5709C23.2524 57.8159 26.3743 59.6207 29.6441 61C14.2988 49.0755 12.2968 27.8922 25.1752 13.6787C35.4495 2.34605 52.3636 -1.43965 66.4623 3.66175Z" fill="url(#paint2_linear_19220_90181)"/>
</g>
<defs>
<linearGradient id="paint0_linear_19220_90181" x1="61.5264" y1="62.525" x2="44.0558" y2="24.6603" gradientUnits="userSpaceOnUse">
<stop stop-color="#E51F2D"/>
<stop offset="1" stop-color="#FECF29"/>
</linearGradient>
<linearGradient id="paint1_linear_19220_90181" x1="77.2067" y1="32.6209" x2="46.8072" y2="90.0805" gradientUnits="userSpaceOnUse">
<stop stop-color="#FCC62A"/>
<stop offset="0.26" stop-color="#ED6E2D"/>
<stop offset="0.56" stop-color="#B9599E"/>
<stop offset="1" stop-color="#512283"/>
</linearGradient>
<linearGradient id="paint2_linear_19220_90181" x1="15.4226" y1="52.4118" x2="45.8188" y2="-4.43039" gradientUnits="userSpaceOnUse">
<stop stop-color="#5962AB"/>
<stop offset="0.25" stop-color="#54C3EC"/>
<stop offset="0.56" stop-color="#68B75D"/>
<stop offset="1" stop-color="#FECF29"/>
</linearGradient>
<clipPath id="clip0_19220_90181">
<rect width="92.88" height="86" fill="white"/>
</clipPath>
</defs>
</svg>
`;
